"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkConditionEnum = void 0;
var LinkConditionEnum;
(function (LinkConditionEnum) {
    LinkConditionEnum["FIRST_MATCHUP"] = "FIRST_MATCHUP"; // link is only valid if a matchUp is the first matchUp for a given participant within a structure
})(LinkConditionEnum || (exports.LinkConditionEnum = LinkConditionEnum = {}));
//# sourceMappingURL=link_condition.js.map